<div class="cards-container">
    <ng-container *ngFor="let user of users; let userIndex = index">
        <div class="animated-col d-flex">
            <div class="user-card ccc ccc-hover flex-grow-1">
                <div class="d-flex justify-content-end mb-4">
                    <button class="btn delete-btn delete-btn-circle"
                        [disabled]="myUserId === user.userId"
                        (click)="myUserId !== user.userId && deleteUser(user.userId)">
                        <i class="app-icon icon icon-delete icon-lg"></i>
                    </button>
                </div>

                <div class="card-item card-title fw-bold fs-4 mb-3 cursor-pointer" (click)="redirectUserDetails(user.userId)">
                  <span HJSuppress class="number">{{user.name}}</span>
                </div>
                <div class="card-item card-email mb-3">
                    <span HJSuppress class="number">{{user.email}}</span>
                </div>
                <div class="card-item card-phone fw-semibold mb-3">
                    <span HJSuppress class="number">{{user.phone}}</span>
                </div>
                <div class="card-item card-switcher mb-3">
                    <kendo-switch [(ngModel)]="user.isActive"
                        name="users-switch-{{userIndex}}"
                        (valueChange)="changeUserStatus(user.userId, $event)"
                        [disabled]="myUserId === user.userId"
                    ></kendo-switch>
                </div>
                <div class="card-item card-user-rights" *ngIf="user.externalProviderId">
                    <span class="l-user-rights">
                        {{ 'users.add.placeholder.externalProvider'  | translate }}
                    </span>
                </div>

                <div class="card-item">
                    <button class="btn delete-btn gap-2"
                        [disabled]="myUserId === user.userId"
                        (click)="myUserId !== user.userId && redirectUserDetails(user.userId)">
                        <i class="app-icon icon icon-edit icon-lg me-2 text-secondary"></i>
                        <span>{{'users.add.placeholder.userDetails' | translate}}</span>
                    </button>
                </div>
            </div>
        </div>
    </ng-container>
</div>
